export default __webpack_public_path__ + "static/media/step - 5.c5d4fe92.jpeg";